var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#F0047F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91815 2.62909C5.05815 2.62909 4.39815 3.05909 3.91815 3.58909L4.47815 4.36909C4.70815 4.01909 5.16815 3.58909 5.92815 3.58909C6.69815 3.58909 7.11815 4.01909 7.11815 4.54909C7.11815 5.11909 6.48815 5.47909 6.04815 5.93909C5.54815 6.45909 5.41815 7.07909 5.43815 7.50909H6.39815C6.40815 6.97909 6.63815 6.59909 7.13815 6.18909C7.71815 5.70909 8.07815 5.26909 8.07815 4.54909C8.07815 3.67909 7.44815 2.62909 5.91815 2.62909ZM5.91815 8.06909C5.51815 8.06909 5.19815 8.38909 5.19815 8.78909C5.19815 9.18909 5.51815 9.50909 5.91815 9.50909C6.32815 9.50909 6.63815 9.18909 6.63815 8.78909C6.63815 8.38909 6.32815 8.06909 5.91815 8.06909Z",
    fill: "#F0047F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionMark);
export default __webpack_public_path__ + "static/media/circle-question-mark.e338918c.svg";
export { ForwardRef as ReactComponent };